<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ title }}</span>
    </div>
    <div class="main-content">
      <div :key="listKey" class="list">
        <el-checkbox
          v-for="(listItem, index) in list"
          v-model="listChecked[index]"
          :disabled="listItem.disabled"
          :key="index"
          class="list-item"
          >{{ listItem.label }}</el-checkbox
        >
      </div>
      <div class="bottom-button">
        <el-tooltip
          class="item"
          :visible-arrow="false"
          effect="light"
          :content="tooltipContent"
          placement="bottom-start"
        >
          <el-button
            class="el-icon-check check-button"
            @click="checkAllClick"
            size="mini"
          ></el-button>
        </el-tooltip>
        <el-button
          @click="buttonClick"
          class="confirm-button"
          :disabled="list.length === 0"
          >{{ buttonName }}</el-button
        >
        <div
          class="add-tasks-buttons"
          v-if="currentRoute === 'sectionTasksLink'"
        >
          <el-tooltip
            class="item"
            :visible-arrow="false"
            effect="light"
            :content="$t('transferList.selectBytTasks')"
            placement="bottom-start"
          >
            <el-button
              class="el-icon-check check-button"
              @click="bytClick"
              size="mini"
              >{{ $t('transferList.byt') }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            :visible-arrow="false"
            effect="light"
            :content="$t('transferList.selectPromTasks')"
            placement="bottom-start"
          >
            <el-button
              class="el-icon-check check-button"
              @click="promClick"
              size="mini"
              >{{ $t('transferList.prom') }}</el-button
            >
          </el-tooltip>
        </div>
        <div v-else style="margin-right: 80px;"></div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      listChecked: [],
      tooltipContent: this.$t('transferList.selectAll'),
      listKey: 0,
      currentRoute: "",
    };
  },
  props: ["list", "buttonName", "title"],
  created() {
    this.clearList();
    let currentRoute = this.$router.currentRoute.name;
    this.currentRoute = currentRoute;
  },
  methods: {
    clearList() {
      this.listChecked = [];
      this.list.forEach((listItem) => {
        this.listChecked.push(false);
      });
    },
    buttonClick() {
      let array = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.listChecked[i]) {
          array.push(this.list[i].id);
        }
      }
      if (array.length === 0) {
        this.$store.commit(
          "setError",
          this.$t('transferList.noSelectedElementsOperationError')
        );
      } else this.$emit("click", array);
    },
    checkAllClick() {
      let value;
      if (this.tooltipContent === this.$t('transferList.selectAll')) {
        value = true;
        this.tooltipContent = $t('transferList.unselect');
      } else {
        value = false;
        this.tooltipContent = $t('transferList.selectAll');
      }
      for (let i = 0; i < this.listChecked.length; i++) {
        this.listChecked[i] = value;
      }
      this.listKey++;
    },
    bytClick() {
      this.clearList();
      let bytRegex = new RegExp("^(быт:|побут:|hh:).*");
      for (let i = 0; i < this.list.length; i++) {
        if (bytRegex.test(this.list[i].label)) {
          this.listChecked[i] = true;
        }
      }
      this.listKey++;
    },
    promClick() {
      this.clearList();
      let promRegex = new RegExp("^(пром:|ind:).*");
      for (let i = 0; i < this.list.length; i++) {
        if (promRegex.test(this.list[i].label)) {
          this.listChecked[i] = true;
        }
      }
      this.listKey++;
    },
  },
  watch: {
    list() {
      this.clearList();
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 1em;
}
.list {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
}
.list-item {
  margin-bottom: 5px;
}
.clearfix {
  text-align: center;
  color: white;
}
.bottom-button {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.check-button {
  /* transform: scale(0.8); */
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 9px;
  /* position: absolute; */
}
.add-tasks-buttons {
  margin-right: 0px;
}
.confirm-button {
  margin-left: 50px;
  padding: 5px 10px !important;
  transform: scale(0.9);
  /* margin-top: 9px; */
}
.main-content {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.list::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.list::-webkit-scrollbar-thumb {
  background-color: grey;
}
</style>